import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Cookies } from "react-cookie-consent";
import { ToastContainer } from "react-toastify";
import config from "../../config";

import App from "../App";
import Legal from "../Legal";
import PaymentStatus from "../PaymentStatus";
import PageNotFound from "../PageNotFound";
import CookieConsentBanner from "../../components/CookieConsentBanner";
import { removeAnalyticCookies } from "../../components/CookieConsentBanner";

// Route paths
export const homeRoutePath = "/";
export const legalRoutePath = "/legal";
export const paymentStatusRoutePath = "/paymentstatus";

const CoreRouter: React.FC = () => {
  const handleProtectedRoutes = (Component: any, props: any) => {
    const consentCookie = Cookies.get(config.cookies.consentCookieLabel);
    if (consentCookie && consentCookie === "false") {
      removeAnalyticCookies();
    }
    return <Component {...props} />;
  };

  return (
    <Router>
      <div className="main">
        <Routes>
          <Route
            path={homeRoutePath}
            Component={(props: any): any => handleProtectedRoutes(App, props)}
          />
          <Route
            path={`${legalRoutePath}/:policyType`}
            Component={(props: any): any => handleProtectedRoutes(Legal, props)}
          />
          <Route
            path={`${paymentStatusRoutePath}/*`}
            Component={(props: any): any =>
              handleProtectedRoutes(PaymentStatus, props)
            }
          />
          <Route
            path="*"
            Component={(props: any): any =>
              handleProtectedRoutes(PageNotFound, props)
            }
          />
        </Routes>
        <CookieConsentBanner />
        <ToastContainer />
      </div>
    </Router>
  );
};

export default CoreRouter;
